import { LOGOS, BANNER } from "@constants/images";
import Button from "@components/common/Button.component";
import { useNavigate } from "react-router-dom";
// import ImageLoader;
import ImageLoader from "../../../loader/ImageLoader";

const Gangstabet = ({ block }: any) => {
  const navigate = useNavigate();
  const blockTypes: any = {
    gangstabet: {
      logo: LOGOS.GANGSTABET,
      desc:
        "GangstaBet is a collection of 5,555 unique Gangsters and Detectives living in the ICON blockchain. GangstaBet NFTs can be upgraded by burning $GBET tokens, which are distributed daily to holders. Owners can create unique character names, increase level & stats and add text stories to their GangstaBets.",
      image: BANNER.GANGSTBET,
      explore: "/gangstabet",
      view_page: "https://gangstabet.io/",
    },
    emeraldCity: {
      logo: LOGOS.EMERALD_CITY,
      desc:
        "The Emerald City is the first virtual major city to be launched as part of the GangstaVerse. Gangsters and Detectives will protect lands and have duels to gain control and ultimately rule The Emerald City.",
      ytLink: "https://www.youtube.com/embed/dg8hclFntDw",
      explore: "/emeraldCity",
      view_page: "https://emerald.gangstabet.io/",
    },
    Dao: {
      logo: LOGOS.AGORA,
      desc:
        "GangstaVerseDAO is a governance system where the community can help make important decisions in the GangstaVerse ecosystem esp. on brand direction, ecosystem fund, and project direction. CROWN and xCROWN can be used to participate in governance.",
      image: BANNER.AGORA,
      explore: "#",
      view_page: "https://emerald.gangstabet.io/",
    },
  };

  return (
    <div className={`gb-block-main wow animate__animated animate__fadeInLeft`}>
      <div className="gb-block">
        <div className="gb-logo-desc">
          <img
            className={`logo ${block === "agora" && "agora-logo"} `}
            src={blockTypes[block]["logo"]}
            alt={`${block} logo`}
          />
          <p className="gb-desc">{blockTypes[block]["desc"]}</p>
          {block !== "Dao" && (
            <div className="btn-group-web">
              <Button onClick={() => navigate(blockTypes[block]["explore"])}>
                Read More
              </Button>
              <div className="outline-btn-wrapper">
                <Button
                  variant="outlined"
                  onClick={() =>
                    window.open(blockTypes[block]["view_page"], "_blank")
                  }
                >
                  Visit Site
                </Button>
              </div>
            </div>
          )}
        </div>
        {blockTypes[block]?.ytLink ? (
          <div className="yt-video">
            <iframe
              src={blockTypes[block]["ytLink"]}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        ) : (
          <ImageLoader
            className="block-image"
            src={blockTypes[block]["image"]}
            alt={`${block}-img`}
            skeletonClassName={"block-image-skeleton"}
          />
        )}
        <div className="btn-group-mobile">
          <Button
            fullWidth
            onClick={() => navigate(blockTypes[block]["explore"])}
          >
            Read More
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() =>
              window.open(blockTypes[block]["view_page"], "_blank")
            }
          >
            Visit Site
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Gangstabet;
